import { render, staticRenderFns } from "./UgcPurchases.vue?vue&type=template&id=3f7eeaa0&"
import script from "./UgcPurchases.vue?vue&type=script&lang=js&"
export * from "./UgcPurchases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports